exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy-wrap {\n  padding: 50px 0; }\n  .privacy-wrap p, .privacy-wrap li {\n    font-family: 'helveticaneuethin';\n    margin: 0 0 25px; }\n  .privacy-wrap li {\n    margin-bottom: 15px; }\n  .privacy-wrap b {\n    font-family: 'helveticaneuemedium';\n    font-weight: normal; }\n  .privacy-wrap h3 {\n    margin-bottom: 30px; }\n  .privacy-wrap h5 {\n    font-size: 18px;\n    margin: 30px 0 20px; }\n  .privacy-wrap a {\n    text-decoration: none;\n    color: #292b2c;\n    font-family: 'helveticaneuemedium'; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/privacy-policy/privacy-policy.component.scss
// module id = ../../../../../src/app/components/privacy-policy/privacy-policy.component.scss
// module chunks = main